import { ERemaxGlobalStatusSync } from "../../store/qrtk/services/remax-global/models/remax-global-status-sync";

export const RemaxGlobalAdapter = (data: {
  sync_status: ERemaxGlobalStatusSync;
  sync_error_message: {
    errors: {
      level: string;
      code: string;
      message: string;
    }[];
  };
}) => {
  return {
    syncStatus: data?.sync_status,
    syncErrorMessage: data?.sync_error_message?.errors.map(error => ({
      level: error.level,
      code: error.code,
      message: replaceLabelMessage(error.message)
    }))
  };
};

export interface IRemaxGlobalStatusSyncAdapter {
  syncStatus: ERemaxGlobalStatusSync;
  syncErrorMessage: {
    level: string;
    code: string;
    message: string;
  }[];
}

const LABEL_REPLACEMENTS: Record<string, string> = {
  // ## Associate
  ExternalID: "error desconocido, contacta a soporte (ExternalID)",
  OfficeExternalID: "error desconocido, contacta a soporte (OfficeExternalID)",
  InternationalID: "ID internacional",
  IsSalesAssociate: "error desconocido, contacta a soporte (IsSalesAssociate)",
  FirstName: "nombre",
  LastName: "apellido",
  Email: "email",
  MainSpecialization: "error desconocido, contacta a soporte (MainSpecialization)",
  Title: "error desconocido, contacta a soporte (Title)", //Rol

  // ## Property
  AssociateExternalID: "error desconocido, contacta a soporte (AssociateExternalID)",
  TransactionType: "error desconocido, contacta a soporte (TransactionType)",
  PropertyType: "Tipo de propiedad",
  ListingStatus: "error desconocido, contacta a soporte (ListingStatus)",
  ContractType: "error desconocido, contacta a soporte (ContractType)",
  CityID: "Ciudad",
  CurrentListingPrice: "Precio actual",
  CurrentListingCurrency: "Moneda actual",
  LivingArea: "error desconocido, contacta a soporte (LivingArea)",
  TotalNumOfRooms: "Total de habitaciones",
  NumberOfBathrooms: "Total de baños",

  // ## Office
  OfficeName: "Nombre de la oficina",
  Address1: "Dirección 1",
  PostalCode: "Código postal",
  Phone: "Teléfono",
  Latitude: "Latitud",
  Longitude: "Longitud"
};

const replaceLabelMessage = (message: string): string => {
  if (typeof message !== "string") {
    return "Error desconocido, contacta a soporte";
  }

  Object.entries(LABEL_REPLACEMENTS).forEach(([key, value]) => {
    message = message.replace(new RegExp(key, "g"), value);
  });

  return message;
};

// ## Associate
// ExternalID  // que es esto?
// OfficeExternalID // que es esto?
// InternationalID // ID internacional
// IsSalesAssociate // que es esto?
// FirstName // nombre
// LastName // apellido
// Email // email
// MainSpecialization // especialidad
// Title // que es esto?

// ## Property
// ExternalID // que es esto?
// AssociateExternalID // que es esto?
// TransactionType // que es esto?
// PropertyType // tipo de propiedad
// ListingStatus // que es esto?
// ContractType // que es esto?
// CityID // Ciudad
// CurrentListingPrice // Precio actual
// CurrentListingCurrency // Moneda actual
// LivingArea // que es esto?
// TotalNumOfRooms // Total de habitaciones
// NumberOfBathrooms // Total de baños

// ## Office
// ExternalID // que es esto?
// InternationalID // ID internacional
// OfficeName // nombre de la oficina
// Address1 // dirección 1
// PostalCode // código postal
// Email // email
// Phone // teléfono
// CityID // Ciudad
// Latitude // latitud
// Longitude // longitud
